import { Typography, Button } from '@mui/material'

const LegendButton = ({handleClick, name, color, shouldDisplay, largeMode, onClickData }) => {

    const onClick = () => handleClick(onClickData)

    return (
        <Button onClick={onClick} size="small" style={{color}}>
            <div style={{
                marginRight: '8px',
                width: '16px',
                border: `${largeMode ? '3px' : '1px'} ${shouldDisplay ? 'solid' : 'dashed'} ${color}`,
                transitionDuration: '200ms',
            }}
            />
            <Typography color="textPrimary">
                {name}
            </Typography>
        </Button>
    )
}

export default LegendButton